import axios from 'axios';
import { getVisitorId } from './visitTracking';
import { setActivePromoEvent } from './activePromoEvent';

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Memoized so the multiple PromoStrip slot-instances on the homepage share ONE fetch.
let promoPromise = null;
export const getHomepagePromo = async () => {
  if (!promoPromise) {
    const visitorId = getVisitorId();
    promoPromise = axios
      .get(`${BASE_URL}/homepage-promo`, { params: { visitorId } })
      .then((r) => {
        // Mirror the active event captured by the discount-config fetch (same
        // server-side resolution) so attribution works even on pages without it.
        if (r.data?.event) setActivePromoEvent(r.data.event);
        return r.data?.data || null;
      })
      .catch((e) => {
        promoPromise = null; // allow a retry on next call
        console.error('Error fetching homepage promo:', e);
        return null;
      });
  }
  return promoPromise;
};
